import { useCallback } from 'react';
import iconDownload from '../../../icons/download.svg';
import iconSummary from '../../../icons/summary.svg';
import { FormattedMessage } from 'react-intl';

const Pagination = ({ currentPage, rowCount, rowsPerPage, onChangePage, onChangeRowsPerPage, onExport, onSummary, isSummary }) => {
  const perPageOptions = [10, 25, 50, 100];
  const getNumberOfPages = (rowCount, rowsPerPage) => Math.ceil(rowCount / rowsPerPage);
  const numPages = getNumberOfPages(rowCount, rowsPerPage);
  const disabledLesser = currentPage === 1;
  const disabledGreater = currentPage === numPages;

  const handlePrevious = useCallback(() => onChangePage(currentPage - 1), [currentPage, onChangePage]);
  const handleNext = useCallback(() => onChangePage(currentPage + 1), [currentPage, onChangePage]);
  const handlePageChange = useCallback((page) => onChangePage(page), [onChangePage]);
  const handleRowsPerPage = useCallback(
    ({ target }) => onChangeRowsPerPage(Number(target.dataset.rows), currentPage),
    [currentPage, onChangeRowsPerPage]
  );

  const pages = () => {
    const pagesNumbersCollection = [];

    pagesNumbersCollection.push(1);

    if (currentPage === 2 && numPages > 2) {
      pagesNumbersCollection.push(currentPage);
    }

    if (currentPage > 2) {
      if (currentPage !== 3) {
        pagesNumbersCollection.push('...');
      }

      pagesNumbersCollection.push(currentPage - 1);

      if (currentPage < numPages) {
        pagesNumbersCollection.push(currentPage);
      }
    }

    if (currentPage < numPages - 1) {
      pagesNumbersCollection.push(currentPage + 1);

      if (numPages - currentPage !== 2) {
        pagesNumbersCollection.push('...');
      }
    }

    if (numPages > 1) {
      pagesNumbersCollection.push(numPages);
    }

    return pagesNumbersCollection.map((page) => {
      if (isNaN(page)) {
        return (
          <span className='ellipsis' key={page}>
            {page}
          </span>
        );
      } else {
        return (
          <span
            className={`page ${currentPage === page ? 'active' : ''}`}
            onClick={() => handlePageChange(page)}
            key={page}
            data-page={page}
          >
            {page}
          </span>
        );
      }
    });
  };

  return (
    <div className='rdt_Pagination pagination'>
      <div className='per-page-container'>
        <span className='label'>Pokaż:</span>
        {perPageOptions.map((num) => (
          <span className={`per-page ${num === rowsPerPage ? 'active' : ''}`} onClick={handleRowsPerPage} key={num} data-rows={num}>
            {num}
          </span>
        ))}
      </div>
      <div className='pagination-container'>
        {isSummary && (
          <div className='summary' onClick={onSummary}>
            <img src={iconSummary} alt='' />
            <span>
              <FormattedMessage id='Results summary' />
            </span>
          </div>
        )}
        <div className='export' onClick={onExport}>
          <img src={iconDownload} alt='' />
          <span>
            <FormattedMessage id='Export to file' />
          </span>
        </div>
        <span>
          <span
            id='pagination-previous-page'
            className={`navigation previous ${disabledLesser ? 'disabled' : ''}`}
            onClick={() => (disabledLesser ? null : handlePrevious())}
          >
            <FormattedMessage id='Previous' />
          </span>
          {pages()}
          <span
            id='pagination-next-page'
            className={`navigation next ${disabledGreater ? 'disabled' : ''}`}
            onClick={() => (disabledGreater ? null : handleNext())}
          >
            <FormattedMessage id='Next' />
          </span>
        </span>
      </div>
    </div>
  );
};

export default Pagination;
